import type { ReactNode } from 'react'

export function LegalSection({ title, children }: { title: string; children: ReactNode }) {
  return <section className="mt-10 space-y-3">
    <h2 className="text-2xl font-semibold tracking-tight">{title}</h2>
    {children}
  </section>
}

export function LegalList({ children }: { children: ReactNode }) {
  return <ul className="list-disc space-y-2 pl-6">{children}</ul>
}

export const legalLinkClass = 'font-semibold text-[color:var(--ui-primary)] underline underline-offset-2'

export function ExternalLink({ href, children }: { href: string; children: ReactNode }) {
  return <a href={href} target="_blank" rel="noreferrer" className={legalLinkClass}>{children}</a>
}
